<template>
  <v-app app>
    <v-main>
      <top-bar-component></top-bar-component>
      <!-- Provides the application the proper gutter -->
      <v-container fluid class="pt-0">
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";

import TopBarComponent from "./components/common/TopBarComponent";
import i18n from "@/i18n";
import store from "@/store/store";
export default {
  name: "App",
  components: {
    TopBarComponent,
  },
  data: () => ({}),
  mounted() {
    //let socketIO = io();
    // socketIO.on('call-to-shop:*', function(data){
    //   console.log('vue event: ', data);
    // });
  },
  computed: {
    ...mapFields("auth", ["authenticated", "authenticatedUser"]),
    ...mapFields("site", ['lang']),
  },
  methods:{
    setLangAndCurrency(lang){
      this.$i18n.locale = lang;
      this.$store.dispatch('site/setLangAndCurrency', lang).then(()=>{
        this.$i18n.locale = lang;
        this.i18n.locale = lang;
      })
      document.title = this.$t('common.page_title');
    }
  },
  watch:{
    authenticatedUser(){
      if(this.authenticatedUser.shop) {
        this.setLangAndCurrency(this.authenticatedUser.shop.lang)
      }
      document.title = this.$t('common.page_title')
    }
  }
};
</script>
<style lang="scss">
.text--red {
  color: red;
}
.pointer {
  cursor: pointer;
}
.dashed {
  border-bottom: dashed 1px #c5c5c5;
  cursor: pointer;
}
.overflow-scroll {
  overflow: auto;
}
.theme--light {
  .text-field-bg {
    background: #fff;
  }
  .select-on-transparent {
    .v-input__slot {
      background: #fff !important;
    }
  }
}

.theme--light {
  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #fff;
    border-left: 1px solid #e7e7e7;
  }

  *::-webkit-scrollbar-thumb {
    background: #fff;
    border: solid 1px #d3d3d3;
    border-radius: 3px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: #faf7f7;
  }
  *::-webkit-scrollbar-corner {
    background: white;
  }
}

.theme--dark {
  .text-field-bg {
    background: #121212;
  }
  .select-on-transparent {
    .v-input__slot {
      background: #121212 !important;
    }
  }
  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #202020;
    border-left: 1px solid #2c2c2c;
  }

  *::-webkit-scrollbar-thumb {
    background: #3e3e3e;
    border: solid 3px #202020;
    border-radius: 7px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: white;
  }
  *::-webkit-scrollbar-corner {
    background: #2c2c2c;
  }
}
.brandWithoutLogo {
  width: 19px;
  height: 19px;
  display: block;
  background: #d9d6d6;
  text-align: center;
  color: white;
  border-radius: 10px;
}
</style>
